import Vue from "vue";
import apiList from "@/service/apiList";
import goodsApi from "@/service/basic/goodsApiList";
import { Message } from "element-ui";
import { postForm } from "@/service/api";
const myhost = hostname;
// 获取商城分类
function getGoodsList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.goodsList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 编辑商品
function editGoods(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.editGoods + params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 商品更新 商品库存更新 停用启用
function updateGoods(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.updateGoods, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 批量启用停用
function batchEnable(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.batchEnable, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 更新变更数量
function updateStock(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.updateStock, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 更新待审核价格
function updateNewPrice(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.updateNewPrice, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取所有商品列表
function getSelectionGoodsList(params) {
  // let manageData = await getGoodsList()
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.selectionGoodsList, params)
      .then(function(res) {
        if (res.data && res.data.code === 401) {
          Message.error("请求超时，请重新查询！");
        }
        // if (res.data && res.data.list) {
        //   for (let i of manageData.list) {
        //     res.data.list = res.data.list.filter(item => {
        //       return item.bianma !== i.ruigu_code
        //     })
        //   }
        // }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 选品
function goodsSelection(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.goodsSelection, params)
      .then(function(res) {
        if (res.code === 200) {
          Message.success("选品成功");
        }
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 店铺开关
function onoffShop(params, that) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.onoffShop, params)
      .then(function(res) {
        if (res.code === 200) {
          Message.success("修改成功!");
        }
        resolve(res);
      })
      .catch(function(err) {
        that.storeswitch = !that.storeswitch;
        console.log(err);
      });
  });
}
// 库存管理 导入数据
function importData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.importData, params)
      .then(function(res) {
        if (res.code === 200) {
          Message.success("数据导入中，请在【导入记录日志】中查询导入结果。");
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
function importCodeData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.importCodeData, params)
      .then(function(res) {
        if (res.code === 200) {
          Message.success("数据导入中，请在【导入记录日志】中查询导入结果。");
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 获取批量导入日志
function importList(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.importList, params)
      .then(function(res) {
        resolve(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 导出库存
function exportStockData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exportStockData, params)
      .then(function(res) {
        if (res.message === "Success") {
          // Message.success(
          //   '导出库存成功，请在邮箱中查收!今日已导出' + res.data + '次'
          // )
          Message.success(
            "库存管理报表导出成功，请在报表中心查看下载！今日已导出" +
              res.data +
              "次"
          );
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 数据导出 todo
function doExportData(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exportStockData, params)
      .then(function(res) {
        if (res.message === "Success") {
          Message.success({
            message: `<div>库存管理报表导出成功，请在  <a href="/#/notice/exportReport">报表中心</a>查看下载！今日已导出${res.data}次</div>`,
            duration: 6000,
            showClose: true,
            dangerouslyUseHTMLString: true
          });
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 导出商品选品
function exportGoodsSelect(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exportGoodsSelect, params)
      .then(function(res) {
        if (res.message === "Success") {
          // Message.success(
          //   '导出成功，请在邮箱中查收!今日已导出' + res.data + '次'
          // )
          Message.success(
            "商品选品报表导出成功，请在报表中心查看下载！今日已导出" +
              res.data +
              "次"
          );
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 导出商品管理
function exportGoodsManage(params) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.exportGoodsManage, params)
      .then(function(res) {
        if (res.message === "Success") {
          // Message.success(
          //   '导出成功，请在邮箱中查收!今日已导出' + res.data + '次'
          // )
          Message.success(
            "商品管理报表导出成功，请在报表中心查看下载！今日已导出" +
              res.data +
              "次"
          );
        }
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}

/**
 * 更新库位信息
 * @param params
 * @returns {Promise<any>}
 */
function updateStoragePos(params = {}) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .post(apiList.updateStoragePos, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
function getStockCountList(params = {}) {
  return new Promise(resolve => {
    Vue.prototype.$api
      .get(apiList.getStockCountList, params)
      .then(function(res) {
        resolve(res);
      })
      .catch(function(err) {
        console.log(err);
      });
  });
}
// 取消选品 - （上传文件）
function goodsCancel(params = {}) {
  return postForm(`${myhost}${goodsApi.postGoodsCancel}`, params);
}
export {
  getGoodsList,
  editGoods,
  batchEnable,
  updateGoods,
  updateStock,
  updateNewPrice,
  getSelectionGoodsList,
  goodsSelection,
  onoffShop,
  importData,
  importCodeData,
  importList,
  exportStockData,
  doExportData,
  exportGoodsSelect,
  exportGoodsManage,
  updateStoragePos,
  getStockCountList,
  goodsCancel
};



// WEBPACK FOOTER //
// ./src/models/goodsModel.js